var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-cart__additional",
      class: {
        "sidebar-cart__additional--open": _vm.additionalOpen
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "sidebar-cart__additional-title",
          class: {
            "sidebar-cart__additional-title--empty": !_vm.additionalItems.length
          }
        },
        [
          _c(
            "div",
            { staticClass: "sidebar-cart__additional-title-text" },
            [
              _c("SVGSticksAngled", {
                staticClass: "sidebar-cart__additional-title-icon"
              }),
              _vm._v(" "),
              _c("a", {
                staticClass: "sidebar-cart__additional-title-link",
                attrs: { href: "" },
                domProps: {
                  innerHTML: _vm._s(_vm.$t("cart.additionalProducts.title"))
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onAdditionalToggle.apply(null, arguments)
                  }
                }
              }),
              _vm._v(" "),
              _c("Button", {
                staticClass: "sidebar-cart__additional-title-edit",
                attrs: {
                  icon: "edit",
                  text: "",
                  type: "button",
                  level: "tertiary"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onAdditionalEdit.apply(null, arguments)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "sidebar-cart__additional-title-price",
            domProps: {
              innerHTML: _vm._s(
                _vm.$options.filters.fwgpricecent(
                  _vm.additionalItemsPrice,
                  "short"
                )
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          ref: "additionalitems",
          staticClass: "sidebar-cart__additional-list"
        },
        _vm._l(_vm.additionalItems, function(item) {
          return _c(
            "li",
            { key: item.id, staticClass: "sidebar-cart__additional-item" },
            [
              _c("div", {
                staticClass: "sidebar-cart__additional-item-amount",
                domProps: { innerHTML: _vm._s(item.quantity) }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "sidebar-cart__additional-item-name",
                domProps: { innerHTML: _vm._s(item.name) }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "sidebar-cart__additional-item-price",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$options.filters.fwgpricecent(
                      item.originalTotal,
                      "short"
                    )
                  )
                }
              })
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }